<template>
  <div>
    <div class="e-sign-banner banner-div row">
      <div class="bannerDiv col-sm-1  col-md-1"></div>
      <div class="bannerDiv col-sm-4 col-md-4">
        <br />
        <h3>iOS企业签名</h3>
        <br />
        <h6>使用企业证书签名iOS 应用</h6>
        <p></p>
        <h6>无需提交 App Store</h6>
        <p></p>
        <h6>免越狱、无限制安装，安全稳定</h6>
        <br />
        <br />
        <el-button style="width:10em" @click="startESign">立即使用</el-button>
      </div>
      <div class="col-sm-6 col-md-6">
        <img class="banner-img" src="../assets/img/supersign-hd-bg.png" />
      </div>
      <div class="col-sm-1 col-md-1"></div>
    </div>
    <div class="module-inner">
      <br />
      <div class="actions-box">
        <h2>功能介绍</h2>
        <br />
        <div class="list row">
          <div class="item col-sm-3">
            <img src="../assets/img/book.png" alt="">
            <p></p>
            <h6>苹果官方企业证书</h6>
            <p>使用苹果官方企业证书</p>
            <p>根据证书品质分类，独立证书备货充足</p>
          </div>
          <div class="line"></div>
          <div class="item col-sm-3">
            <img src="../assets/img/sign.png" alt="">
            <p></p>
            <h6>全自动签名系统</h6>
            <p>高可靠的 7*24 小时全自动签名系统</p>
            <p>在线完成应用的签名、重签和更新版本操作</p>
          </div>
          <div class="item col-sm-3">
            <img src="../assets/img/buqian.png" alt="">
            <p></p>
            <h6>有效期内免费更新、补签</h6>
            <p>如在应用有效期内掉签</p>
            <p>免费提供不限次的重签服务</p>
          </div>
          <div class="item col-sm-3">
            <img src="../assets/img/free.png" alt="">
            <p></p>
            <h6>签名到期短信提醒</h6>
            <p>已签名应用到期前3天</p>
            <p>我们将通过短信提前通知</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    startESign: function() {
      this.$router.push({ name: "SignOnline" });
    }
  },
  components: {}
};
</script>

<style scoped>
.item img {
  height: 6em;
}

@media (max-width: 768px) {
  .e-sign-banner {
    height: 45em;
  }
}

@media (min-width: 1200px) {
  .banner-img {
    margin-top: 3em;
    width: 50em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESign.vue